import PropTypes from 'prop-types'
import React from 'react'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'
import UserSearchResult from './UserSearchResult'

function UserSearchResultSuccess({title, userId, userInfo, warning, resetSearch}) {
  const resultText = `ID ${userId} | ${userInfo}`

  return (
    <UserSearchResult
      modifier="success"
      resetSearch={resetSearch}
      header={
        <>
          <div className="title">{title}</div>
          {warning && <div className="title title--warning">{warning}</div>}
        </>
      }
      content={
        <TriggerWithTooltip text={resultText} modifiers={['dark', 'nopadding', 'modal']}>
          <span>{resultText}</span>
        </TriggerWithTooltip>
      }
    />
  )
}

UserSearchResultSuccess.propTypes = {
  title: PropTypes.string,
  userId: PropTypes.number,
  userInfo: PropTypes.string,
  warning: PropTypes.string,
  resetSearch: PropTypes.func,
}

export default UserSearchResultSuccess
